export const getRequestHeaders = (extraHeaders?: Record<string, string>): Record<string, string> => {
  const tokenInput = document.querySelector<HTMLInputElement>('input[name="__RequestVerificationToken"]');
  return {
    ...(tokenInput?.value && { RequestVerificationToken: tokenInput.value }),
    ...extraHeaders,
  };
};
